// based off https://github.com/noeldelgado/values.js
export default function rgbToHex(r, g, b) {
  return (0x1000000 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}